/**
 * JSON Editor Component
 * JSON input for direct network execution (Execute button is in parent header)
 */
import React from 'react';

export default function JsonEditor({ value, onChange, disabled }) {
  const [jsonError, setJsonError] = React.useState(null);

  const validateJson = (str) => {
    try {
      JSON.parse(str || '{}');
      setJsonError(null);
      return true;
    } catch (e) {
      setJsonError(e.message);
      return false;
    }
  };

  const handleInputChange = (e) => {
    const v = e.target.value;
    onChange(v);
    validateJson(v);
  };

  return (
    <div className="h-full flex flex-col">
      <div className="flex-1 min-h-0 relative">
        <textarea
          value={value}
          onChange={handleInputChange}
          disabled={disabled}
          className="w-full h-full p-4 font-mono text-sm border border-gray-200 rounded-lg resize-none outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-200 transition-all disabled:bg-gray-50"
          spellCheck={false}
          placeholder='{"key": "value"}'
        />
        {jsonError && (
          <div className="absolute bottom-2 left-2 right-2 px-3 py-1.5 bg-red-50 border border-red-200 rounded-md">
            <p className="text-xs text-red-600 font-mono truncate">⚠ {jsonError}</p>
          </div>
        )}
      </div>
    </div>
  );
}
